import {
  LegacyAccountUser,
  toLegacyAccountUser,
} from '@/api/queries/me/toLegacyAccountUser';
import useGetMyAccountUsersIncludeDeactivated from '@/api/queries/me/useGetMyAccountUsersIncludeDeactivated';
import { useMemo } from 'react';

const emptyUsers: LegacyAccountUser[] = [];

/**
 * Account users in the legacy REST shape (numeric `id`, `firstname`,
 * `userColour`, …) — see {@link toLegacyAccountUser}.
 */
export const useAccountUsers = (): LegacyAccountUser[] => {
  const { data } = useGetMyAccountUsersIncludeDeactivated();
  return useMemo(() => data?.map(toLegacyAccountUser) ?? emptyUsers, [data]);
};
